import React from 'react'

import { toPx } from 'common/builder/components/chart/utils/toPx'

export const Colors = {
  BODY: '#2C323A',
  BORDER: '#C1C9D6',
  DISABLED: '#8D9EB2',
  SECONDARY: '#65758B',
  PRIMARY: '#0084FF',
  HOVER: '#EBEEF1',
  WARNING: '#FFC300',
  DANGER: '#EB5038',
  // BLOCKS
  BLOCK_DYNAMIC: '#EFEAFF',
  BLOCK_DEFAULT: '#EEF1F4',
  BLOCK_SYSTEM: '#F3F0FF',
  // BUTTONS
  BUTTON_MESSENGER: '#FBFBFB',
  BUTTON_BACKGROUND: '#FBFBFB',
  // MISC
  BLACK: '#000000',
  YELLOW: '#FFF4D8',
  STARTING_STEP_ICON: '#5A677D',
  TRIGGER_BG: '#E1FAEC',
  DISABLED_TRIGGER_BG: '#F6F7F9',
  // full white has issues on some OS/Graphics cards, using almost white value
  WHITE: '#FEFEFE',
  CYAN_40: '#18D8B8',
  ACTIONS_CONNECTOR: '#FFD96F',
  PURPLE_LIGHT: '#7E5BEF',
  PRIMARY_MUTED: '#EEF7FF',
  GREEN: '#0BCB6B',
  Tints: {
    NEUTRAL: [
      '#000000',
      '#3C4858',
      '#8492A6',
      '#BEC5CF',
      '#E0E6ED',
      '#EBEEF1',
      '#F9FAFC',
      '#FFFFFF',
    ],
  },
}

export const Spacings = {
  EXTRA_EXTRA_SMALL: 2,
  EXTRA_SMALL: 4,
  SMALL: 8,
  SMALL_HORIZONTAL: 12,
  BLOCK_VERTICAL_SPACING: 12,
  NORMAL: 16,
  MEDIUM: 20,
  MEDIUM_HORIZONTAL: 24,
  NEXT_STEP_VERTICAL_MARGIN: 22,
  NODE_HORIZONTAL_PADDING: 28,
  LARGE: 32,
  MEDIUM_LARGE: 36,
  EXTRA_LARGE: 40,
}

export const NEXT_STEP_DOT_SIZE = 22

export const BorderRadius = {
  EXTRA_SMALL: 6,
  SMALL: 12,
  NORMAL: 16,
  MEDIUM: 20,
  LARGE: 30,
}

export const BorderWidth = {
  SMALL: 1,
  NORMAL: 2,
  MEDIUM: 3,
}

export const IconSizes = {
  SMALL: 16,
  SMALL_MEDIUM: 20,
  NORMAL: 24,
  MEDIUM: 32,
  MEDIUM_LARGE: 36,
  LARGE: 48,
}

export const FontSizes = {
  SMALL: 18,
  NORMAL: 20,
  MEDIUM: 22,
  LARGE: 24,
}

export const BoxShadows = {
  NODE: '0px 4px 8px rgba(129, 148, 175, 0.35)',
}

export const Opacity = {
  DISABLED: 0.4,
}

export const column: React.CSSProperties = {
  display: 'flex',
  flexDirection: 'column',
}

export const row = {
  display: 'flex',
}

export const rowWrap = {
  ...row,
  flexWrap: 'wrap',
}

export const empty = {
  backgroundColor: '',
  borderRadius: toPx(BorderRadius.NORMAL),
  borderWidth: toPx(BorderWidth.NORMAL),
  borderColor: Colors.BORDER,
  borderStyle: 'dashed',
  borderDashStyle: '7px 5px',
}

export const text = {
  color: Colors.BODY,
  fontFamily: 'InterVariable, Arial, sans-serif',
  fontSize: '22px',
  lineHeight: 1.5,
}

export const preheader = {
  ...text,
  color: Colors.SECONDARY,
  fontSize: '18px',
  lineHeight: '22px',
}

export const small = {
  ...text,
  fontSize: '20px',
}

export const subheading = {
  ...text,
  fontSize: '24px',
}

export const heading = {
  ...text,
  fontSize: '30px',
}

export const commentText = {
  ...text,
  fontSize: '30px',
  lineHeight: '40px',
}

export const commentTextLarge = {
  ...text,
  fontSize: '56px',
  lineHeight: '64px',
}

export const textDisabled = {
  color: Colors.DISABLED,
}

export const textSecondary = {
  color: Colors.SECONDARY,
}

export const textPrimary = {
  color: Colors.PRIMARY,
}

export const textBlack = {
  color: Colors.BLACK,
}

export const chip = {
  ...row,
  alignItems: 'center',
  padding: '3px 12px',
  background: Colors.BODY,
  borderRadius: toPx(BorderRadius.EXTRA_SMALL),
}

export const chipText = {
  ...text,
  color: Colors.WHITE,
  lineHeight: 1,
}

// Nodes

export const nextStep = {
  justifyContent: 'flex-end',
  // In Figma vertical margin is 24, but because of line-height=1.2 by default we should use 22
  margin: '22px 0',
}

export const nodeContentWrapper = {
  display: 'flex',
  margin: '24px 28px 0 28px',
}

export const nodePlaceholderContentWrapper = {
  display: 'flex',
  margin: '12px 28px 0 28px',
}

export const nodeWithoutContent = {
  padding: '0 0 36px',
}

export const nodeContentItem = {
  ...nodeContentWrapper,
  paddingBottom: 20,
  borderBottom: '1px solid #E7EAEE',
}

export const nodeContentItemColumn: React.CSSProperties = {
  ...nodeContentItem,
  flexDirection: 'column',
}

export const messengerBlock: React.CSSProperties = {
  ...column,
  padding: `16px 20px`,
  borderRadius: toPx(BorderRadius.MEDIUM),
  background: Colors.BLOCK_DEFAULT,
}

export const systemBlock = {
  ...column,
  padding: `0px 20px`,
  borderRadius: toPx(BorderRadius.MEDIUM),
  background: Colors.BLOCK_SYSTEM,
}

export const messengerBlockEmpty = {
  ...messengerBlock,
  ...empty,
}

export const textEllipsis: React.CSSProperties = {
  whiteSpace: 'nowrap',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
}

export const CONTENT_BLOCK_SHADOW = '0px 2px 4px rgba(132, 146, 166, 0.8)'

export const respondentsBadge = {
  background: Colors.PURPLE_LIGHT,
}
